import type { EntityConfig } from '../types'

export const memberEntity: EntityConfig = {
  id: 'member',
  displayName: 'Member',
  status: {
    filters: [
      { value: 'all', label: 'All' },
      { value: 'active', label: 'Active' },
      { value: 'inactive', label: 'Inactive' },
      { value: 'suspended', label: 'Suspended' },
      { value: 'pending', label: 'Pending' }
    ],
    options: [
      { value: 'active', label: 'Active', color: 'success' },
      { value: 'inactive', label: 'Inactive', color: 'neutral' },
      { value: 'suspended', label: 'Suspended', color: 'error' },
      { value: 'pending', label: 'Pending', color: 'pending' }
    ],
    mappings: {
      all: ['active', 'inactive', 'suspended', 'pending'],
      active: ['active'],
      inactive: ['inactive'],
      suspended: ['suspended'],
      pending: ['pending']
    }
  },
  queryFields: {},
  uiFilterFields: [
    'search',
    'status',
    'dateRange',
  ]
}
